import React from 'react';

interface CapoSelectorProps {
  useCapo: boolean;
  setUseCapo: (use: boolean) => void;
  capoFret: number;
  setCapoFret: (fret: number) => void;
  maxFrets: number;
}

const CapoSelector: React.FC<CapoSelectorProps> = ({ 
  useCapo, 
  setUseCapo, 
  capoFret, 
  setCapoFret, 
  maxFrets 
}) => {
  return (
    <div className="form-control">
      <label className="label cursor-pointer">
        <span className="label-text">Use Capo</span>
        <input
          type="checkbox"
          className="toggle"
          checked={useCapo}
          onChange={(e) => setUseCapo(e.target.checked)}
        />
      </label>
      
      {useCapo && (
        <>
          <label className="label">
            <span className="label-text">Capo Position:</span>
            <span className="label-text-alt">Fret {capoFret}</span>
          </label>
          <input
            type="range"
            min="0"
            max={maxFrets}
            value={capoFret}
            className="range"
            step="1"
            onChange={(e) => setCapoFret(parseInt(e.target.value))}
          />
          <div className="w-full flex justify-between text-xs px-2">
            <span>Fret 0</span>
            <span>Fret {maxFrets}</span>
          </div>
        </>
      )}
    </div>
  );
};

export default CapoSelector;